// libraries.
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

// slices.
import { apiBudgetRoute } from "../apiSlices";

// interfaces.
import { ModelError } from "../interfaces/interfaces";
import { ToggleRuleBody } from "./interfaces/rawRules.interfaces";

interface ToggleRuleApiResponse {
  success: boolean;
  data: { rule_id: string; is_active: string; action: string };
  message: string;
}

export const toggleRulesEndpoints = apiBudgetRoute.injectEndpoints({
  endpoints: (builder) => ({
    toggleRule: builder.mutation<void, ToggleRuleBody>({
      query: (body) => ({
        url: "/rules",
        method: "PATCH",
        body,
      }),
      transformErrorResponse: (error: FetchBaseQueryError) => {
        const modelError: ModelError = {
          errorStatus: error.status,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          messageFromServer: (error.data as any)?.message,
          serviceErrorName: "toggleRule",
        };
        return modelError;
      },
      transformResponse: (_raw: ToggleRuleApiResponse) => undefined,
    }),
  }),
});

export const { useToggleRuleMutation } = toggleRulesEndpoints;
